export { default } from "bullitttime-embermodelsgochips/adapters/passing";
